import { isEmbedded } from '../services/embedded/embeddedService';

// Notifies the embedded parent (Stigg) that a contract was published, mirroring
// the download flow in triggerDownload.ts.
//
// Only fires in the embedded (cross-origin iframe) flow — in the standalone app
// there is no parent to notify. The parent validates event.source against its
// own iframe's contentWindow, so targetOrigin '*' is safe here.
//
// The message contract is fixed by the parent listener and must not drift:
//   { type: 'received:contract-published', contractId, action }
// `action` distinguishes a first publish ('created') from republishing edits to
// an already-active contract ('updated').
export type ContractPublishedAction = 'created' | 'updated';

export const notifyContractPublished = (contractId: string | undefined, action: ContractPublishedAction): void => {
	if (!isEmbedded()) return;
	window.parent.postMessage({ type: 'received:contract-published', contractId, action }, '*');
};
